import { render, staticRenderFns } from "./TabDetailPenawaranRejected.vue?vue&type=template&id=0f409240&scoped=true"
import script from "./TabDetailPenawaranRejected.vue?vue&type=script&lang=js"
export * from "./TabDetailPenawaranRejected.vue?vue&type=script&lang=js"
import style0 from "./TabDetailPenawaranRejected.vue?vue&type=style&index=0&id=0f409240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f409240",
  null
  
)

export default component.exports